module.exports = __webpack_public_path__ + "prod/1.42.2/img/font2.1d1a468e.png";